import { Goal } from './Goal';

export const kind = 'Destroy';

export type Destroy = Goal<typeof kind>;
